import { SagaIterator } from '@redux-saga/core'
import { all, takeLatest, put, call } from 'redux-saga/effects'
import { CONTENT } from 'ducks/aboutLayout'
import getAboutLayout from 'services/getAboutLayout'
import { Action } from 'lib/redux/models'

function* loadAboutLayout(action: Action) {
  yield put(CONTENT.request())
  try {
    const { data } = yield call(getAboutLayout, action.payload)
    if (data) {
      yield put(CONTENT.success(data.aboutUsLayout))
    }
  } catch (error) {
    yield put(CONTENT.failure(error.message))
  } finally {
    yield put(CONTENT.fulfill())
  }
}

export function* aboutLayoutSagas(): SagaIterator {
  yield all([takeLatest(CONTENT.TRIGGER, loadAboutLayout)])
}
